module.exports = __webpack_public_path__ + "img/Vector1.9c1a3338.png";